<app-common-modal-container [title]="heading | translate" (modalClose)="cancel()">
  <ng-container body>
    <div class="warning-container">
      <i *ngIf="showWarning" class="icon-warning-default-24"></i>
      <div>
        {{ content | translate}}
      </div>
      <ng-content></ng-content>
    </div>
  </ng-container>

  <ng-container footer>
    <app-button [kind]="'primary'" (clicked)="cancelHandler()" *ngIf="!showOnlyOne" [label]="cancelButtonLabel | translate"></app-button>
    <app-button [kind]="'primaryLoud'" (clicked)="confirmHandler()" [label]="saveButtonLabel | translate"></app-button>
  </ng-container>
</app-common-modal-container>
